const editorRouter = [
	{
		path: '/project',
		name: 'Project',
		component: () => import('../template/BasicTemplate.vue'),
	},
]

export default editorRouter
